<template>
<div v-if="!!registration && !!registration.requester">
  <v-dialog v-model="showDenialReasonDialog" width="500px">
        <v-card class="search-modal">
        <h2>Denial Reason?</h2>
        <v-form class="search-form">
            <v-textarea
            outlined
            v-model="reason"
            ></v-textarea>
            <v-btn
                    dark
                    large
                    color="primary"
                    width="125px"
                    v-on:click="denyRequest"
                >Deny</v-btn>     
        </v-form>
        </v-card>
  </v-dialog>
  <v-dialog v-model="showCancellationReasonDialog" width="500px">
        <v-card class="search-modal">
            <v-alert type="warning">
                In case payment has been already processed, you need to process the refund manually.
            </v-alert>  
            <h2>Cancellation Reason?</h2>
            <v-form class="search-form">
                <v-textarea
                outlined
                v-model="cancellationReason"
                ></v-textarea>
                <v-btn
                        dark
                        large
                        color="primary"
                        width="125px"
                        v-on:click="cancelRequest"
                    >Cancel</v-btn>     
            </v-form>
        </v-card>
  </v-dialog>  
  <v-dialog v-model="showProvideSignatureNotes" width="500px">
        <v-card class="search-modal">
        <h2>Signature Notes</h2>
        <v-form class="search-form">
            <v-textarea
            outlined
            v-model="signatureNotes"
            ></v-textarea>
            <v-btn
                    dark
                    large
                    color="primary"
                    width="125px"
                    v-on:click="signSignatureByAdmin"
                >Save</v-btn>     
        </v-form>
        </v-card>
  </v-dialog>
  <v-dialog v-model="showProvideSignature2Notes" width="500px">
        <v-card class="search-modal">
        <h2>Signature Notes</h2>
        <v-form class="search-form">
            <v-textarea
            outlined
            v-model="signature2Notes"
            ></v-textarea>
            <v-btn
                    dark
                    large
                    color="primary"
                    width="125px"
                    v-on:click="signSignature2ByAdmin"
                >Save</v-btn>     
        </v-form>
        </v-card>
  </v-dialog>
  <v-dialog v-model="showProvidePaymentNotes" width="500px">
        <v-card class="search-modal">
        <h2>Payment Notes</h2>
        <v-form v-model="adminPaymentValid" class="search-form">
            <v-autocomplete
                v-model="paymentType"
                label="Payment Method"
                :items="paymentTypes"
                item-text="description"
                item-value="id"
                :rules="[(v) => !!v || 'Payment method is required']"
            />
            <v-textarea outlined v-model="paymentNotes" />
            <v-btn
                :dark="adminPaymentValid && !processingRequest"
                large
                color="primary"
                width="125px"
                :disabled="!adminPaymentValid || processingRequest"
                v-on:click="markPaidByAdmin"
            >Save</v-btn>
        </v-form>
        </v-card>
  </v-dialog>
  <v-sheet color="white" elevation="5" rounded class="mt-5 mb-5 pt-3 pb-5 pl-3 pr-3">
    <v-row class="mb-3">
        <v-col cols="4">
            <p>
                <h3>
                    <b>
                        {{registration.requester.firstName}} {{registration.requester.lastName}}
                        <span v-if="registration.requester.memberId"> (Member ID: {{registration.requester.memberId}})</span>    
                    </b>                                     
                </h3>
                <span>
                    <b>Email:</b> {{registration.requester.email}}<br/> 
                    <b>Ph:</b> {{registration.requester.phoneNumber}}
                </span><br/><br/>
                <span>   
                    <b>Request Status: </b> {{registration.status}} 
                </span><br/>
                <span>
                    <b>Date Submitted:</b> {{$dateUtils.formatDateTime(registration.submittedAt)}}
                </span><br/>             
                <span v-if="!registration.payment">
                    <b>Payment Status:&nbsp;&nbsp;</b>
                    <span v-if="!!registration.paymentAuthorized">
                        <b>Authorization:&nbsp;</b>
                        <v-tooltip dark right>
                            <template v-slot:activator="{ on, attrs }">
                            <font-awesome-icon icon="credit-card" :color="registration.paymentAuthorized ? 'green' : 'red'"  
                                    v-bind="attrs"
                                    v-on="on"/>
                            </template>    
                            <span>{{registration.paymentAuthorized ? 'Authorized' : 'Authorization Rejected'}}</span>
                        </v-tooltip>&nbsp;
                    </span>  
                    <span>
                        <b>Capture:&nbsp;</b>
                        <v-tooltip dark right>
                            <template v-slot:activator="{ on, attrs }">
                            <font-awesome-icon icon="credit-card" 
                                    :color="registration.paymentCaptured ? 'green' : 
                                            registration.paymentAuthorized ? 'gray' 
                                            :'red'"  
                                    v-bind="attrs"
                                    v-on="on"/>
                            </template>    
                            <span>{{registration.paymentCaptured ? 'Paid' 
                                    : registration.paymentAuthorized ? 'Not Captured'
                                    :'Payment Rejected'}}</span>
                        </v-tooltip>
                    </span>   
                    <span>                        
                        <v-btn 
                            v-if="!registration.paymentCaptured"
                            v-on:click="showProvidePaymentNotes = true"
                            color="primary"
                            class="white--text">
                            Mark paid
                        </v-btn>
                    </span>
                </span>
            </p>                 
         </v-col>
         <v-col cols="8" elevation="5">
          <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <h3>Request Timeline</h3>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-timeline dense clipped >
                        <v-timeline-item v-for="event in registration.events" v-bind:key="event.guid"
                            color="pink"
                            small
                        >
                            <v-card class="elevation-2">
                                <v-card-text>
                                    <v-row justify="space-between">
                                        <v-col cols="6">
                                            {{$dateUtils.formatDateTime(event.createdAt)}}
                                        </v-col>
                                        <v-col cols="6">
                                            {{ event.eventName }}  
                                        </v-col>
                                        <v-col cols="12">
                                            {{ JSON.parse(event.data) }}  
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-timeline-item>
                    </v-timeline>    
                </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          </v-col>
        </v-row>
        <v-row v-if="!!registration.payment">
            <v-col cols="12">
                <h3>Payment</h3>
                <span v-if="!!registration.payment.payee">
                    <b>Payee: </b>
                    {{registration.payment.payee.firstName}} {{registration.payment.payee.lastName}} 
                    <span v-if="registration.payment.payee.memberId"> (Member ID: {{registration.payment.payee.memberId}})</span>
                </span><br/>
                <span v-if="registration.payment.needsPaymentAuthorization">
                    <b>Authorized: </b>
                    <v-tooltip dark right>
                        <template v-slot:activator="{ on, attrs }">
                        <font-awesome-icon icon="credit-card" :color="registration.payment.authorized ? 'green' : 'red'"  
                                v-bind="attrs"
                                v-on="on"/>
                        </template>    
                        <span>{{registration.payment.authorized ? 'Authorized' : 'Authorization Rejected'}}</span>
                    </v-tooltip>&nbsp;    
                </span>
                <span>
                    <b>Captured: </b>
                    <v-tooltip dark right>
                        <template v-slot:activator="{ on, attrs }">
                        <font-awesome-icon icon="credit-card" 
                                :color="registration.payment.captured ? 'green' :'red'"  
                                v-bind="attrs"
                                v-on="on"/>
                        </template>    
                        <span>{{registration.payment.captured ? 'Paid' 
                                : registration.payment.authorized ? 'Not Captured'
                                :'Payment Rejected'}}</span>
                    </v-tooltip>&nbsp;
                    <b>Dollar Amount: </b> ${{registration.payment.transactionAmount}}
                </span><br/>
                <span v-if="!!registration.payment.paidAt">
                    <b>Paid At: </b> {{$dateUtils.formatDateTime(registration.payment.paidAt)}}
                </span> <br/>
                <span>
                    <b>Authorize.NET transaction id:&nbsp;</b> <span> {{ registration.payment?.transactionId }} </span>
                </span>
                <div v-if="!registration.payment.captured">
                    <v-btn
                        v-on:click="showProvidePaymentNotes = true"
                        color="primary"
                        class="white--text">
                        Mark paid
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row class="pb-5">
          <v-col cols="12">
            <slot name="registrationWarnings" />  
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div v-if="registration.signatories.length > 0">
                <h3>Signatories</h3>
                <p>
                    <v-simple-table fixed-header :height="Math.min(180, (registration.signatories.length + 1) * 60)">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">Name</th>
                                    <th class="text-left">Membership ID</th>
                                    <th class="text-left"></th>
                                    <th class="text-left"></th>
                                    <th class="text-left">Email</th>
                                    <th class="text-left">Phone Number</th>
                                    <th class="text-left">Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="signatory in registration.signatories" :key="signatory.personId">
                                    <td>
                                        {{ signatory.firstName }} {{ signatory.lastName }}
                                    </td>    
                                    <td>{{ signatory.memberId }}</td>
                                    <td>
                                        <v-tooltip dark right>
                                            <template v-slot:activator="{ on, attrs }">
                                                <font-awesome-icon icon="signature" :color="signatory.signed ? 'green' : 'red'" 
                                                v-bind="attrs"
                                                v-on="on"/>
                                            </template>    
                                            <span>{{(signatory.signed && signatory.signedByAdmin) ? 'Signed by admin' : signatory.signed ? 'Signed in web portal': 'Not signed'}}</span>
                                        </v-tooltip>
                                    </td>
                                    <td>
                                        <v-btn 
                                            v-if="!!signSignatureByAdminFn && !signatory.signed && !signatory.isCancelled"
                                            v-on:click="provideSignatureNotes(signatory.signatureId)"
                                            color="primary"
                                            class="white--text">
                                            Mark signed
                                        </v-btn>
                                    </td>    
                                    <td>{{ signatory.email }}</td>
                                    <td>{{ signatory.phoneNumber }}</td>
                                    <td>{{ signatory.adminNotes }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </p>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div v-if="!!registration.signatories2 && registration.signatories2.length > 0">
                <h3>{{ signatories2Header }}</h3>
                <p>
                    <v-simple-table fixed-header :height="Math.min(180, (registration.signatories2.length + 1) * 60)">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">Name</th>
                                    <th class="text-left">Membership ID</th>
                                    <th class="text-left"></th>
                                    <th class="text-left"></th>
                                    <th class="text-left">Email</th>
                                    <th class="text-left">Phone Number</th>
                                    <th class="text-left">Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="signatory in registration.signatories2" :key="signatory.personId">
                                    <td>
                                        {{ signatory.firstName }} {{ signatory.lastName }}
                                    </td>    
                                    <td>{{ signatory.memberId }}</td>
                                    <td>
                                        <v-tooltip dark right>
                                            <template v-slot:activator="{ on, attrs }">
                                                <font-awesome-icon icon="signature" :color="signatory.signed ? 'green' : 'red'" 
                                                v-bind="attrs"
                                                v-on="on"/>
                                            </template>    
                                            <span>{{(signatory.signed && signatory.signedByAdmin) ? 'Signed by admin' : signatory.signed ? 'Signed in web portal': 'Not signed'}}</span>
                                        </v-tooltip>
                                    </td>
                                    <td>
                                        <v-btn 
                                            v-if="!!signSignature2ByAdminFn && !signatory.signed && !signatory.isCancelled"
                                            v-on:click="provideSignature2Notes(signatory.signatureId)"
                                            color="primary"
                                            class="white--text">
                                            Mark signed
                                        </v-btn>
                                    </td>    
                                    <td>{{ signatory.email }}</td>
                                    <td>{{ signatory.phoneNumber }}</td>
                                    <td>{{ signatory.adminNotes }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </p>
            </div>
          </v-col>
        </v-row>
        <v-row class="pb-5">
          <v-col cols="12">
            <slot :requestContent="requestContent"></slot>  
          </v-col>
        </v-row>
        <div>    
        </div>   
        <v-overlay :value="processingRequest">
            <v-progress-circular 
                indeterminate color="primary"
                :size="70" :width="7"
            ></v-progress-circular>
      </v-overlay>
      <div v-if="(registration.status === 'RequestFinalized' || registration.status === 'PaymentCaptured')">
        <v-row class="ma-0">
            <v-spacer></v-spacer>
            <v-btn
                light
                large
                v-on:click="provideDenialReason()"
                :disabled="processingRequest"
                color="light"
                width="125px"
                class="mr-5"
            >Deny</v-btn>
            <v-btn
                dark
                large
                v-on:click="approveRequest()"
                :disabled="processingRequest"
                color="primary"
                width="125px"
            >Approve</v-btn>
        </v-row>      
      </div>
      <div v-if="!(!cancelRegistrationRequestFn) && !(registration.status === 'RequestFinalized' || registration.status === 'PaymentCaptured' 
                    || registration.status === 'WorkflowCompleted' || registration.status === 'RequestApproved'|| registration.status === 'RequestDenied')">
    
        <v-btn
            dark
            large
            v-on:click="provideCancellationReason()"
            :disabled="processingRequest"
            color="primary"
            width="125px"
            >Cancel</v-btn>
      </div>
  </v-sheet>
</div>  
</template>

<script lang="ts">
import Vue from 'vue';
import { UserInfo } from "@/types/User";

export default Vue.extend({
  name: 'RegistrationRequestLayout',
  props: {
    requestId: { type: Number },
    onRequestProcessed: { type: Function },
    cancelRegistrationRequestFn: { type: Function },
    denyRegistrationRequest: { type: Function },
    approveRegistrationRequest: { type: Function },
    getRegistrationRequestById: { type: Function },
    setRegistrationData: { type: Function },
    signSignatureByAdminFn: { type: Function },
    markPaidByAdminFn: { type: Function },
    signatories2Header: { type: String },
    signSignature2ByAdminFn: { type: Function },
  },
  components: {
  },
  data: function() {
      return {
          showCancellationReasonDialog: false,
          cancellationReason: '',
          showDenialReasonDialog: false,
          showProvideSignatureNotes: false,
          showProvideSignature2Notes: false,
          showProvidePaymentNotes: false,
          reason: "",
          signatureNotes: "",
          signature2Notes: "",
          adminPaymentValid: false,
          paymentNotes: "",
          paymentType: 1,
          paymentTypes: [
            {
                id: 1,
                description: "Credit Card Online Payment",
            },
            {
                id: 2,
                description: "Credit Card Office Payment",
            },
            {
                id: 3,
                description: "Check",
            },
            {
                id: 4,
                description: "Wire Transfer",
            },
            {
                id: 5,
                description: "Cash",
            },
            {
                id: 6,
                description: "PayPal",
            },
            {
                id: 7,
                description: "Other",
            }
          ],
          signatureId: null,
          processingRequest: false,
          registration: { } as any,
          isLoading: false,
      };
  },
  created() {
      this.isLoading = true;
      this.getRegistrationRequestById(this.requestId).then((res: { data: any; }) => {
          this.isLoading = false;
          this.registration = res.data;
          this.setRegistrationData(res.data);
      });
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
  watch: {
    requestId: function (newValue) {
      this.isLoading = true;
      this.getRegistrationRequestById(newValue).then((res: any) => {
          this.isLoading = false;
          this.registration = res;
      });
    }
  },
  methods: {    
    provideCancellationReason: function () {
        this.$data.showCancellationReasonDialog = true;
    },
    approveRequest: function() {
      this.processingRequest = true;
      this.approveRegistrationRequest(this.registration.workflowGuid, this.registration.requestId).then((res: any) => {
        this.onRequestProcessed(this.registration.requestId);
      }).catch(this.$handleError)
        .finally(() => this.processingRequest = false);
    },
    provideDenialReason: function () {
        this.$data.showDenialReasonDialog = true;
    },
    provideSignatureNotes: function (signatureId: number){
        this.$data.showProvideSignatureNotes = true;
        this.$data.signatureId = signatureId;
    },
    provideSignature2Notes: function (signatureId: number){
        this.$data.showProvideSignature2Notes = true;
        this.$data.signatureId = signatureId;
    },    
    denyRequest: function() {
      this.showDenialReasonDialog = false;
      this.processingRequest = true;
      this.denyRegistrationRequest(this.registration.workflowGuid, this.registration.requestId, this.$data.reason).then((res: any) => {
        this.onRequestProcessed(this.registration.requestId);
      }).catch(this.$handleError)
        .finally(() => this.processingRequest = false);
    },    
    cancelRequest: function() {
      this.showCancellationReasonDialog = false;
      this.processingRequest = true;
      this.cancelRegistrationRequestFn(this.registration.workflowGuid, this.registration.requestId, this.userInfo.personId, this.$data.cancellationReason).then((res: any) => {
        this.onRequestProcessed(this.registration.requestId);
      }).catch(this.$handleError)
        .finally(() => this.processingRequest = false);
    }, 
    signSignatureByAdmin: function(){
        this.processingRequest = true;

        this.signSignatureByAdminFn(this.registration.workflowGuid, this.signatureId, this.userInfo.personId, this.signatureNotes).then((res: any) => {
            this.$data.signatureNotes = "";
            this.$data.signatureId = null;
            this.$data.showProvideSignatureNotes = false;
            this.getRegistrationRequestById(this.requestId).then((res: { data: any; }) => {
                this.isLoading = false;
                this.registration = res.data;
                this.setRegistrationData(res.data);
            });
        });
        
        this.processingRequest = false;
    },
    signSignature2ByAdmin: function(){
        this.processingRequest = true;

        this.signSignature2ByAdminFn(this.registration.workflowGuid, this.signatureId, this.userInfo.personId, this.signature2Notes).then((res: any) => {
            this.$data.signature2Notes = "";
            this.$data.signatureId = null;
            this.$data.showProvideSignature2Notes = false;
            this.getRegistrationRequestById(this.requestId).then((res: { data: any; }) => {
                this.isLoading = false;
                this.registration = res.data;
                this.setRegistrationData(res.data);
            });
        });
        
        this.processingRequest = false;
    },
    markPaidByAdmin: function() {
        this.processingRequest = true;
        
        this.markPaidByAdminFn(this.registration.workflowGuid, this.userInfo.personId, this.paymentNotes, this.paymentType).then((res: any) => {
            this.$data.paymentType = 1;
            this.$data.paymentNotes = "";
            this.$data.adminPaymentValid = false;
            this.$data.showProvidePaymentNotes = false;
            this.getRegistrationRequestById(this.requestId).then((res: { data: any; }) => {
                this.isLoading = false;
                this.registration = res.data;
                this.setRegistrationData(res.data);
            });
        });

        this.processingRequest = false;
    }
  },
});
</script>
